<template>
  <div>
    <md-content>
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-50">
          <md-field>
            <select v-model="$store.state.plot.localization.municipality" name="municipality" @change="changeMunicipality()">
              <option disabled value="">{{ $t("localization.municipality") }}</option>
              <option v-for="(mun, key) in municipalityList" :value="key" :key="key">{{ mun }}</option>
            </select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-50">
          <md-field>
            <select v-model="$store.state.plot.localization.administrative_limit" name="adminLimit">
              <option disabled value="">{{ $t("localization.adminLimit") }}</option>
              <option v-for="(al, key) in adminLimit" :value="key" :key="key">{{ al }}</option>
            </select>
          </md-field>
        </div>

        <div class="md-layout-item md-size-50">
          <md-field :md-counter="false">
            <label for="localName">{{ $t("localization.localName") }}</label>
            <md-input type="text" name="localName" v-model="$store.state.plot.localization.local_name" maxlength="50" />
          </md-field>
        </div>
        <div class="md-layout-item md-size-50">
          <md-field>
            <select v-model="$store.state.plot.localization.sub_economy" name="economy">
              <option disabled value="">{{ $t("localization.economy") }}</option>
              <option v-for="(eco, key) in economy" :value="key" :key="key">{{ key }} - {{ eco }}</option>
            </select>
          </md-field>
        </div>

        <div class="md-layout-item md-size-50">
          <md-field :md-counter="false">
            <label for="alfisCode">{{ $t("localization.alfisCode") }}</label>
            <md-input type="text" name="alfisCode" v-model="$store.state.plot.localization.alfis_code" maxlength="20" />
          </md-field>
        </div>
        <div class="md-layout-item md-size-25">
          <md-field :md-counter="false" :class="!checkRange($store.state.plot.localization.parcel, 0, 999) ? 'md-invalid' : ''">
            <label for="parcel">{{ $t("localization.parcel") }}</label>
            <md-input type="number" name="parcel" v-model="$store.state.plot.localization.parcel" />
            <span class="md-error">{{ $t("error.errorRange") }} (0-999)</span>
          </md-field>
        </div>
        <div class="md-layout-item md-size-25">
          <md-field :md-counter="false" :class="!checkChar($store.state.plot.localization.sub_parcel) ? 'md-invalid' : ''">
            <label for="subParel">{{ $t("localization.subParcel") }}</label>
            <md-input type="text" name="subPart" v-model="$store.state.plot.localization.sub_parcel" maxlength="1" />
            <span class="md-error">{{ $t("error.errorRange") }} (a-z)</span>
          </md-field>
        </div>

        <div class="md-layout-item md-size-50">
          <md-datepicker v-model="date" md-immediately class="md-primary" />
        </div>
      </div>

      <div class="md-layout md-gutter md-alignment-center-center more-info-btn">
        <md-button class="md-raised md-primary" @click="moreInfo = !moreInfo">
          {{ $t("localization.descParc") }}
          <md-icon>{{ expand }}</md-icon>
        </md-button>
      </div>

      <div class="md-layout md-gutter more-info-section" v-if="moreInfo">
        <!-- Site Description -->
        <expand :label="$t('localization.siteDesc')" group="siteDesc" @expand="expandGroup"></expand>
        <div class="md-layout md-gutter moreInfoGroup" v-if="moreInfoGroup.siteDesc">
          <site-description></site-description>
        </div>

        <!-- Management -->
        <expand :label="$t('localization.management')" group="management" @expand="expandGroup"></expand>
        <div class="md-layout md-gutter moreInfoGroup" v-if="moreInfoGroup.management">
          <management></management>
        </div>

        <!-- Forest Stand -->
        <expand :label="$t('localization.forestStand')" group="forestStand" @expand="expandGroup"></expand>
        <div class="md-layout md-gutter moreInfoGroup" v-if="moreInfoGroup.forestStand">
          <forest-stand :edit="edit"></forest-stand>
        </div>

        <!-- Health -->
        <expand :label="$t('localization.health')" group="health" @expand="expandGroup"></expand>
        <div class="md-layout md-gutter moreInfoGroup" v-if="moreInfoGroup.health">
          <health></health>
        </div>

        <!-- Biodiversity -->
        <expand :label="$t('localization.biodiversity')" group="biodiversity" @expand="expandGroup"></expand>
        <div class="md-layout md-gutter moreInfoGroup" v-if="moreInfoGroup.biodiversity">
          <biodiversity :edit="edit"></biodiversity>
        </div>

        <!-- Herbs -->
        <expand :label="$t('localization.herbs')" group="herbs" @expand="expandGroup"></expand>
        <div class="md-layout md-gutter moreInfoGroup" v-if="moreInfoGroup.herbs">
          <herbs :edit="edit"></herbs>
        </div>

        <div class="md-layout md-gutter md-alignment-center-center md-layout-item md-size-100 event-btn" v-if="!this.edit">
          <md-button class="md-raised md-primary" @click="save(0)">
            {{ $t("page.event") }}
          </md-button>
        </div>
      </div>
    </md-content>

    <buttons-nav :prev="prev" next step="2" @btnPrev="btnPrev()" />

    <error-dialog :show="error" :text="errorText" @closeError="error = false" />
  </div>
</template>

<script>
import ButtonsNav from '@/components/ButtonsNav'
import Expand from '@/components/Expand'
import ErrorDialog from '@/components/ErrorDialog'
// desc parc
import SiteDescription from '@/components/descParc/SiteDescription'
import Management from '@/components/descParc/Management'
import ForestStand from '@/components/descParc/ForestStand'
import Health from '@/components/descParc/Health'
import Biodiversity from '@/components/descParc/Biodiversity'
import Herbs from '@/components/descParc/Herbs'

import { getDomain } from '@/assets/scripts/domainsManager'
import { checkChar, checkYear, checkPercentage, checkRange, normalize } from '@/assets/scripts/formatData'

const MUNICIPALITY = 'municipality'
const ADMIN_LIMIT = 'administrative_limit'
const ECONOMY = 'sub_economy'

export default {
  name: 'Localization',
  components: {
    ButtonsNav,
    Expand,
    ErrorDialog,
    SiteDescription,
    Management,
    ForestStand,
    Health,
    Biodiversity,
    Herbs
  },
  data: () => ({
    date: new Date(),
    municipalityList: [],
    adminLimitList: {},
    economyList: [],
    edit: false,
    error: false,
    errorText: '',
    prev: 'Team',
    next: 'Plot',
    moreInfo: false,
    checkChar: checkChar,
    checkRange: checkRange,
    moreInfoGroup: {
      siteDesc: false,
      management: false,
      forestStand: false,
      health: false,
      biodiversity: false,
      herbs: false
    }
  }),
  mounted: function () {
    // open channels with buttons-nav
    this.$on('next', this.save)

    this.setLists()
    this.$store.state.plot.id === null ? this.edit = false : this.edit = true

    if (this.edit) { // edit
      this.$emit('title', this.$i18n.t('page.localization') + ' (' + this.$i18n.t('global.edit') + ')')
    } else { // new
      this.$emit('title', this.$i18n.t('page.localization') + ' (' + this.$i18n.t('global.new') + ')')
      this.$store.dispatch('plot/getTmp', 'localization')
    }

    if (this.$store.state.plot.localization.dt_update !== '') {
      this.date = new Date(this.$store.state.plot.localization.dt_update)
    }
  },
  computed: {
    adminLimit: function () {
      return this.adminLimitList[this.$store.state.plot.localization.municipality]
    },
    economy: function () {
      return this.economyList[this.$store.state.plot.localization.municipality]
    },
    expand: function () {
      return this.moreInfo === true ? 'expand_less' : 'expand_more'
    }
  },
  watch: {
    // if plotType change clear plot fields
    '$store.state.plot.localization.plotType': function () {
      this.$store.commit('plot/clearState', 'plot')
    }
  },
  methods: {
    changeMunicipality: function () {
      this.$store.state.plot.localization.administrative_limit = ''
      this.$store.state.plot.localization.sub_economy = ''
    },

    setLists: function () {
      getDomain(MUNICIPALITY).then(data => {
        this.municipalityList = data
      })
      getDomain(ADMIN_LIMIT).then(data => {
        this.adminLimitList = data
      })
      getDomain(ECONOMY).then(data => {
        this.economyList = data
      })
    },

    save: function (event) {
      if (!this.edit) {
        if (event !== undefined) {
          this.$store.state.plot.localization.plotType = '02'
        } else {
          this.$store.state.plot.localization.plotType = '01'
        }
      }
      if (this.$store.state.plot.localization.municipality.length > 0 &&
        (this.$store.state.plot.localization.parcel !== null && this.$store.state.plot.localization.parcel !== '')) {
        if (this.checkData()) {
          this.clearArray('bio_hcv')
          this.clearArray('herbs')
          this.$store.state.plot.localization.dt_update = this.parseDate(this.date)

          if (this.$store.state.plot.localization.regeneration_mean_h !== null) this.$store.state.plot.localization.regeneration_mean_h = normalize(this.$store.state.plot.localization.regeneration_mean_h, 1)
          if (this.$store.state.plot.localization.regeneration_mean_d !== null) this.$store.state.plot.localization.regeneration_mean_d = normalize(this.$store.state.plot.localization.regeneration_mean_d, 0)
          if (this.$store.state.plot.localization.regeneration_seedling_nr !== null) this.$store.state.plot.localization.regeneration_seedling_nr = normalize(this.$store.state.plot.localization.regeneration_seedling_nr, 1)
          if (this.$store.state.plot.localization.health_damage_area !== null) this.$store.state.plot.localization.health_damage_area = normalize(this.$store.state.plot.localization.health_damage_area, 0)
          if (this.$store.state.plot.localization.health_dead_tree !== null) this.$store.state.plot.localization.health_dead_tree = normalize(this.$store.state.plot.localization.health_dead_tree, 0)

          this.$store.state.plot.localization.bio_hcv.forEach(item => {
            if (item.dead_wood !== null) item.dead_wood = normalize(item.dead_wood, 0)
            if (item.habitat !== null) item.habitat = normalize(item.habitat, 0)
          })
          this.$store.state.plot.localization.herbs.forEach(item => {
            if (item.area !== null) item.area = normalize(item.area, 0)
          })

          if (!this.edit) {
            this.$store.dispatch('plot/setTmp', 'localization')
          }
          this.$router.push(this.next)
        } else {
          this.errorText = this.$i18n.t('error.dataCheck')
          this.error = true
        }
      } else {
        this.errorText = this.$i18n.t('error.municipalityCheck')
        this.error = true
      }
    },

    parseDate: function (date) {
      return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2)
    },

    getPlotType: function (plotType) {
      this.$store.state.plot.localization.plotType = plotType
    },

    checkData: function () {
      return this.$store.state.plot.localization.plotType.length > 0 &&
        checkRange(this.$store.state.plot.localization.parcel, 0, 999) &&
        checkChar(this.$store.state.plot.localization.sub_parcel) &&
        // forest stand -> origin
        checkYear(this.$store.state.plot.localization.forest_origin_year) &&
        // forest stand -> regeneration
        checkYear(this.$store.state.plot.localization.regeneration_origin_year) &&
        checkRange(this.$store.state.plot.localization.regeneration_mean_h, 0, 10) &&
        checkRange(this.$store.state.plot.localization.regeneration_mean_d, 0, 10) &&
        checkRange(this.$store.state.plot.localization.regeneration_seedling_nr, 0, 9999) &&
        // health
        checkPercentage(this.$store.state.plot.localization.health_damage_area) &&
        checkPercentage(this.$store.state.plot.localization.health_dead_tree) &&
        // biodiversity
        this.checkDataList(this.$store.state.plot.localization.bio_hcv, 'habitat') &&
        this.checkDataList(this.$store.state.plot.localization.bio_hcv, 'dead_wood') &&
        // herbs
        this.checkDataList(this.$store.state.plot.localization.herbs, 'area')
    },

    // manage expand section
    expandGroup: function (group, expand) {
      this.moreInfoGroup[group] = expand
    },

    // check element inside array of object
    checkDataList: function (data, type) {
      let check = true
      data.forEach((item) => {
        if (item !== null && item[type] !== null) {
          if (type === 'dead_wood') {
            if (!checkRange(item[type], 0, 10)) check = false
          } else {
            if (!checkPercentage(item[type])) check = false
          }
        }
      })

      return check
    },

    // remove null element from array
    clearArray: function (type) {
      this.$store.state.plot.localization[type] = this.$store.state.plot.localization[type].filter(el => {
        return el != null
      })
    },

    btnPrev: function () {
      this.clearArray('bio_hcv')
      this.clearArray('herbs')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';

  .md-layout {
    .md-layout-item {
      margin-bottom: 10px;
    }
  }

  .more-info-btn {
    margin-top: -10px;
  }

  .more-info-section {
    margin-top: 20px;
  }

  .info-label {
    margin-bottom: 0 !important;
    margin-top: 0;
    label {
      margin-bottom: 0 !important;
      font-weight: bold;
      color: var(--md-primary) !important;
    }
  }

  .disabled {
    user-select: none;
    pointer-events: none;
  }

  .moreInfoGroup {
    margin-right: 0 !important;
    margin-left: 0 !important;
    /* margin-top: 15px !important; */
  }

  .event-btn {
    margin-top: 15px;
  }
</style>
